import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const uploadFixedBudgetVesselAccCodeQuery = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(apiurl?.uploadFixedBudgetVesselAccCode, formData, {
    headers: {
      Accept: '*/*'
    },
    validateStatus: (status) => status >= 200 && status < 600
  });
};

const uploadFixedBudgetVesselAccCode = () => {
  const queryClient = useQueryClient();
  return useMutation(uploadFixedBudgetVesselAccCodeQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getFixedBudgetVesselAccCodeList');
    }
  });
};

export default uploadFixedBudgetVesselAccCode;
